import { render, staticRenderFns } from "./RadioRecliner.vue?vue&type=template&id=672420d8"
import script from "./RadioRecliner.vue?vue&type=script&lang=js"
export * from "./RadioRecliner.vue?vue&type=script&lang=js"
import style0 from "./RadioRecliner.vue?vue&type=style&index=0&id=672420d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports